import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import About from "@/components/site/About";
import Manifesto from "@/components/site/Manifesto";
import Modules from "@/components/site/Modules";
import Program from "@/components/site/Program";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import Enquiry from "@/components/site/Enquiry";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="bg-ink min-h-screen text-white overflow-x-hidden">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <About />
      <Manifesto />
      <Modules />
      <Program />
      <Testimonials />
      <Pricing />
      <Enquiry />
      <Faq />
      <Footer />
    </main>
  );
}
